@if (isMenu) {
  <button mat-menu-item>
    <div class="item-menu-center">
      <span class="material-symbols-outlined"> add_moderator </span>
      {{ 'sendingInArchive' | translate }}
    </div>
  </button>
} @else {
  <button
    mat-icon-button
    [attr.aria-label]="'sendingInArchive' | translate"
    matTooltip="{{ 'sendingInArchive' | translate }}">
    <span class="material-symbols-outlined"> add_moderator </span>
  </button>
}
